// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__\\+5V-h {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
}

.styles_button__vKRuP {
  position: absolute;
  left: 0;
  width: 40px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
}

.styles_heading__W15w\\+ {
  width: 100%;
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #ffffff;
}
@media (max-width: 768px) {
  .styles_heading__W15w\\+ {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LiquidityRemove/pageContent/heading/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCCjBQ;EDkBR,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cC9BM;AD4BR;AEGE;EFTF;IAWI,eAAA;EADF;AACF","sourcesContent":["@import '../../../../assets/styles/variables/colors';\n@import '../../../../assets/styles/mixin/breakpoints';\n\n.wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.button {\n  position: absolute;\n  left: 0;\n  width: 40px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: $white-3;\n  border-radius: 12px;\n}\n\n.heading {\n  width: 100%;\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 30px;\n  text-align: center;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white;\n\n  @include md {\n    font-size: 18px;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__+5V-h`,
	"button": `styles_button__vKRuP`,
	"heading": `styles_heading__W15w+`
};
export default ___CSS_LOADER_EXPORT___;
